/** Defaults for `config/reports` — keep keys in sync with Admin → Reports hub copy. */
export const DEFAULT_REPORTS_HUB_COPY = {
  pageTitle: 'Reports',
  pageSubtitle:
    'Quick and full reports for this property. Uploaded PDFs are shared with everyone who can access this property.',
  introText: '',
  quickReportsHeading: 'Quick reports',
  fullReportsHeading: 'Full reports',
  sustainabilityReportTitle: 'Sustainability Data Report',
  sustainabilityReportDescription: 'In-app sustainability and disclosure-aligned view',
  landHealthReportTitle: 'Land Health Report',
  landHealthReportDescription: 'EcoIntel land health diagnostic',
  fullReportsEmptyMessage:
    'No PDF full reports have been uploaded for this property yet. Admin-uploaded PDFs appear here for every user with access to this property.',
  loadingMessage: 'Loading reports...',
  pdfLinkUnavailableText: '(link unavailable)',
  /** When an uploaded PDF row has no title or file name */
  uploadedReportFallbackTitle: 'Report',
};

/**
 * Merge Firestore `config/reports` document into defaults (string fields only).
 * @param {Record<string, unknown>|null|undefined} data
 */
export function mergeReportsHubCopy(data) {
  const out = { ...DEFAULT_REPORTS_HUB_COPY };
  if (!data || typeof data !== 'object') return out;
  for (const key of Object.keys(DEFAULT_REPORTS_HUB_COPY)) {
    if (typeof data[key] === 'string') {
      out[key] = data[key];
    }
  }
  return out;
}

/** Payload for Firestore `config/reports` (trimmed; empty optional fields fall back to defaults). */
export function buildReportsConfigForSave(copy) {
  const d = DEFAULT_REPORTS_HUB_COPY;
  const t = (v, def) => {
    const x = typeof v === 'string' ? v.trim() : '';
    return x || def;
  };
  return {
    pageTitle: t(copy.pageTitle, d.pageTitle),
    pageSubtitle: t(copy.pageSubtitle, d.pageSubtitle),
    introText: typeof copy.introText === 'string' ? copy.introText : '',
    quickReportsHeading: t(copy.quickReportsHeading, d.quickReportsHeading),
    fullReportsHeading: t(copy.fullReportsHeading, d.fullReportsHeading),
    sustainabilityReportTitle: t(copy.sustainabilityReportTitle, d.sustainabilityReportTitle),
    sustainabilityReportDescription: t(copy.sustainabilityReportDescription, d.sustainabilityReportDescription),
    landHealthReportTitle: t(copy.landHealthReportTitle, d.landHealthReportTitle),
    landHealthReportDescription: t(copy.landHealthReportDescription, d.landHealthReportDescription),
    fullReportsEmptyMessage: t(copy.fullReportsEmptyMessage, d.fullReportsEmptyMessage),
    loadingMessage: t(copy.loadingMessage, d.loadingMessage),
    pdfLinkUnavailableText: t(copy.pdfLinkUnavailableText, d.pdfLinkUnavailableText),
    uploadedReportFallbackTitle: t(copy.uploadedReportFallbackTitle, d.uploadedReportFallbackTitle),
  };
}
